import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteGeneralIncomeType } from '../../../../actions';

const GeneralIncomeTypeDeleteButton = ({
  dispatchDeleteGeneralIncomeType,
  generalIncomeTypeId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteGeneralIncomeType({ generalIncomeTypeId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

GeneralIncomeTypeDeleteButton.propTypes = {
  dispatchDeleteGeneralIncomeType: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  generalIncomeTypeId: PropTypes.number.isRequired,
};

GeneralIncomeTypeDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteGeneralIncomeType: deleteGeneralIncomeType,
};

export default connect(null, mapDispatchToProps)(GeneralIncomeTypeDeleteButton);
